const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconST(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-T",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconS-T1",
    serifid: "iconS-T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.186,4l-0,4.33l-0.425,0c-0.252,-0.999 -0.531,-1.716 -0.838,-2.153c-0.306,-0.437 -0.727,-0.785 -1.262,-1.044c-0.299,-0.142 -0.822,-0.213 -1.57,-0.213l-1.191,0l-0,12.343c-0,0.818 0.045,1.329 0.135,1.533c0.091,0.205 0.268,0.384 0.531,0.537c0.264,0.154 0.624,0.23 1.08,0.23l0.531,0l-0,0.437l-8.378,0l0,-0.437l0.531,0c0.464,0 0.838,-0.082 1.121,-0.247c0.205,-0.11 0.366,-0.299 0.484,-0.567c0.087,-0.189 0.13,-0.684 0.13,-1.486l-0,-12.343l-1.156,0c-1.078,0 -1.861,0.228 -2.349,0.685c-0.684,0.637 -1.117,1.545 -1.297,2.725l-0.449,0l0,-4.33l14.372,0Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconST);
export default __webpack_public_path__ + "static/media/iconS-T.45161fc8f91f1dfa20764aa44b4ee79f.svg";
export { ForwardRef as ReactComponent };